<section class="section--public background--wave">
  <app-pricing-premium></app-pricing-premium>

  <app-public-footer></app-public-footer>
</section>
